import { Box, Stack, TextField, Button, Tooltip, Typography, Autocomplete, FormControlLabel, Checkbox, IconButton, FormControl, InputLabel, Select, MenuItem } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Colors } from '../../../Styles/Colors'
import { DataGrid } from '@mui/x-data-grid'
import { CommonGridToolBarWithFilterText, DeletePopup } from '../../../Components/Common Components/CommonComponents'
import RestAPIService from '../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../Utility/API/Serviceurls'
import ToastMsg from '../../../Components/ToastMsg/ToastMsg'
import { useHistory, useLocation } from 'react-router-dom';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import Loader from '../../../Components/Loader'
import { AmountFormat, CheckAccessFunc } from '../../../Components/CommonFunctions/CommonFunctions'
import { CurrencySymbol } from '../../../Utility/Constants'

const fieldLimits = {
    surgeryCode: 10,
};

export default function AddSurgeryMapping() {
    const location = useLocation();
    const TempId = location.state?.id;
    const history = useHistory();
    const [page, setpage] = useState(0);
    const [pageSize, setpageSize] = useState(10);
    const [formState, setFormState] = useState({
        surgeryNameList: [],
        surgeryCode: '',
        surgeryName: null,
        selectedPackageData: null,
        PackageDataList: [],
        PackageList: []
    });
    const [isActive, setIsActive] = useState(true);
    const [errorMsg, seterrorMsg] = useState(false);
    const [errorMsgText, seterrorMsgText] = useState('');
    const [successMsg, setsuccessMsg] = useState(false);
    const [successMsgText, setsuccessMsgText] = useState('');
    const [isloader, setisloader] = useState(false);
    const [delIDs, setdelIDs] = useState([]);
    const [CheckBoxList, setCheckBoxList] = useState([]);
    const [isDelete, setisDelete] = useState(false);
    const [serviceDetails, setServiceDetails] = useState([]);
    const [surgeryLineItem, setsurgeryLineItem] = useState(null)
    const [apiDeleteIDs, setapiDeleteIDs] = useState(null)
    const [localDeleteIDs, setlocalDeleteIDs] = useState(null)
    let commonDisable = CheckAccessFunc("front_office", "Settings", "Service Master Configuration", "Surgery Mapping", "SubTab")?.editAccess

    useEffect(() => {
        if (TempId) {
            getSurgeryIndividual();
        }
    }, [TempId]);

    useEffect(() => {
        getSurgeryData();
        getPackageData();
    }, []);

    const getSurgeryIndividual = () => {
        try {
            setisloader(true)
            RestAPIService.getAll(Serviceurls.SURGERY_MAPPING_CONFIGURATION + `?get_type=individual&surgery_mapping_id=${TempId}`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setFormState((prevState) => ({
                            ...prevState,
                            surgeryCode: response.data.data?.surgery_map_code,
                        }));
                        setServiceDetails(response.data.data?.line_item || [])
                        const surgeryLineItemIds = response.data.data?.line_item
                            .map(service => service.package_id)
                            .filter(id => id !== null && id !== undefined);
                        setsurgeryLineItem(surgeryLineItemIds);
                        setIsActive(response.data.data?.is_active)
                        setisloader(false)
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const getSurgeryData = () => {
        try {
            setisloader(true)
            RestAPIService.getAll(Serviceurls.IP_SURGERY_NAME_CONFIG)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setisloader(false)
                        const activeSurgeryNames = response?.data?.data?.filter(item => item.is_active) || [];
                        setFormState((prevState) => ({
                            ...prevState,
                            surgeryNameList: activeSurgeryNames
                        }));
                        if (activeSurgeryNames.length > 0 && location.state?.SurgeryName) {
                            let surgeryName = activeSurgeryNames.filter((item) => item?.surgery_name === location.state?.SurgeryName);
                            setFormState((prevState) => ({
                                ...prevState,
                                surgeryName: surgeryName[0]
                            }));
                        }
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const getPackageData = () => {
        try {
            setisloader(true)
            RestAPIService.getAll(Serviceurls.NEW_PACKAGE_CONFIGURATION + `?get_type=get&module_type=IP`)
                .then((response) => {
                    if (response.data.status === 'success') {
                        setisloader(false)
                        setFormState((prevState) => ({
                            ...prevState,
                            PackageList: response?.data?.data || []
                        }));
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const errorMessage = (msg) => {
        seterrorMsgText(msg)
        seterrorMsg(true)
    }
    const successMessage = (msg) => {
        setsuccessMsgText(msg)
        setsuccessMsg(true)
    }

    const onChangeAuto = (e, val, name) => {
        switch (name) {
            case 'surgeryName':
            case 'selectedPackageData':
                setFormState((prevState) => ({
                    ...prevState,
                    [name]: val,
                }));
                break
        }
    }

    const onChangeHandler = (e, name) => {
        const { value } = e.target;

        if (value === "" || value.length <= (fieldLimits[name] || 50)) {
            setFormState((prevState) => ({ ...prevState, [name]: value }));
        }
    };


    const textBox = (label, name, val, width, disable = false) => {
        return (
            <Box>
                <TextField
                    size='small'
                    name={name}
                    autoComplete='off'
                    disabled={disable}
                    value={val ? val : ""}
                    id="drug-master"
                    sx={{ width: width, marginRight: '0.3vw' }}
                    label={label}
                    onChange={(e) => { onChangeHandler(e, name) }}
                    variant="outlined"
                />
            </Box>
        )
    }

    const autoComplete = (label, name, val, list, width, disabled = false) => {
        return (
            <Box>
                <Autocomplete
                    clearIcon
                    size={'small'}
                    options={list}
                    name={name}
                    getOptionLabel={(option) => name === 'surgeryName' ? option?.surgery_name : name === 'selectedPackageData' ? option?.package_name : option}
                    value={val}
                    disabled={disabled}
                    onChange={(event, newValue) => { onChangeAuto(event, newValue, name) }}
                    renderInput={(params) => <TextField {...params} label={label} sx={{ width: width, marginRight: '0.3vw' }} />}
                />
            </Box>
        )
    }

    const grpDelete = () => {
        setisDelete(true)
    }

    const tableView = () => {
        const gridToolBar = () => {
            return (
                <Box>
                    <CommonGridToolBarWithFilterText />
                </Box>
            )
        }

        const handleTableCheckbox = (id) => {
            let selectedIDs = new Set(id);
            setCheckBoxList(id)
            let selectedRows = serviceDetails?.filter((row) => selectedIDs.has(row.sno));
            let finalData = selectedRows.map(item => ({
                line_item_id: item.line_item_id || null,
                package_id: item.package_id,
                sno:item?.sno
            }));
            setdelIDs(finalData)
            setapiDeleteIDs(finalData.filter(item => item.line_item_id).map(item => item.line_item_id));
            setlocalDeleteIDs(finalData.filter(item => !item.line_item_id).map(item => item.sno));
        }
        serviceDetails?.forEach((element,index) => element.sno = index + 1)
        const columns = [
            {
                field: 'package_code', headerName: 'Package Code', flex: 0.5,
                renderCell: (params) => (params.row.package_code ? params.row.package_code?.length > 50 ?
                    <Tooltip placement="top" title={params.row.package_code}><Typography fontSize={'0.9vw'}>{params.row.package_code?.slice(0, 50) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'0.9vw'}>{params.row.package_code}</Typography> : '-')
            },
            {
                field: 'package_name', headerName: 'Package Name', flex: 0.5,
                renderCell: (params) => (params.row.package_name ? params.row.package_name?.length > 50 ?
                    <Tooltip placement="top" title={params.row.package_name}><Typography fontSize={'0.9vw'}>{params.row.package_name?.slice(0, 50) + '...'}</Typography></Tooltip> :
                    <Typography fontSize={'0.9vw'}>{params.row.package_name}</Typography> : '-')
            },
            {
                field: 'package_amount', headerName: `Service Amount (${CurrencySymbol})`, flex: 0.25,
                renderCell: (params) => (<Box component={'div'}>{params?.row?.package_amount ? AmountFormat(params?.row?.package_amount) : "0"}</Box>)
            },
        ]
        return (
            <Box sx={{ height: '42vh', marginTop: '.5vw' }}>
                <DataGrid
                    checkboxSelection={commonDisable ? true : false }
                    selectionModel={CheckBoxList}
                    onSelectionModelChange={(id) => handleTableCheckbox(id)}
                    rows={serviceDetails}
                    columns={columns}
                    getRowId={(row) => row['sno']}
                    page={page}
                    pageSize={pageSize}
                    localeText={{
                        toolbarColumns: "",
                        toolbarDensity: "",
                        toolbarExport: "",
                        toolbarFilters: "",
                        toolbarExportPrint: ""
                    }}
                    hideFooter
                    components={{
                        Toolbar: gridToolBar,
                        NoRowsOverlay: () => (
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                {'No Records To Be Shown'}
                            </Box>
                        )
                    }}
                    onPageChange={(newPage) => { setpage(newPage) }}
                    onPageSizeChange={(newPageSize) => { setpageSize(newPageSize) }}
                    rowsPerPageOptions={[10, 20, 30]}
                    pagination
                    headerHeight={40}
                    density='compact'
                    disableSelectionOnClick
                    loading={isloader}
                />
            </Box>
        )
    }

    const msgClose = () => {
        seterrorMsg(false);
        seterrorMsgText('');
        setsuccessMsg(false);
        setsuccessMsgText('');
    }

    const closeFilter = () => {
        setisDelete(false);
        setCheckBoxList([])
        setdelIDs([])
    }


    const AddTable = () => {
        let newData = {
            line_item_id: formState?.line_item_id || null,
            package_id: formState.selectedPackageData?.id,
            package_code: formState.selectedPackageData?.package_code,
            package_name: formState.selectedPackageData?.package_name,
            package_amount: formState.selectedPackageData?.package_amount
        };

        let errorState = false;

        setServiceDetails((prevState) => {
            let updatedState;
            if (prevState.some(item => item.package_id === newData.package_id)) {
                errorMessage("Package already exists!");
                errorState = true;
                return prevState; // No update, no clearing states
            }
            updatedState = [...prevState, newData];

            return updatedState;
        });

        // Clear form fields only if no error
        if (!errorState) {
            setFormState((prevState) => ({
                ...prevState, serviceName: '', serviceCode: '', selectedPackageData: null
            }));
        }
    }

    const AddSurgeryData = () => {
        try {
            const data = {
                id: TempId,
                surgery_id: formState.surgeryName?.id,
                is_active: isActive,
                no_of_packs: serviceDetails.length,
                line_item: serviceDetails,
            };
            setisloader(true)
            RestAPIService.create(data, Serviceurls.SURGERY_MAPPING_CONFIGURATION)
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        setisloader(false)
                        history.push("/Settings/NewService/SurgeryMapping")
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }

    const deleteSurgeryMapping = async () => {
        try {
            setisloader(true)
            RestAPIService.delete(`${Serviceurls.SURGERY_MAPPING_CONFIGURATION}?delete_type=surgery_mapping&mapping_id=${TempId}`, {})
                .then((response) => {
                    if (response.data.status === 'success') {
                        successMessage(response.data.message)
                        setisloader(false)
                        history.push("/Settings/NewService/SurgeryMapping");
                    }
                }).catch(e => {
                    setisloader(false)
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message)
                    } else {
                        errorMessage(e.message)
                    }
                })
        } catch (e) {
            setisloader(false)
            errorMessage(e.message)
        }
    }
    console.log(localDeleteIDs,'LOCAL',delIDs,'DELIDS',apiDeleteIDs,'APIDEL')
    const deleteIndivudualData = async () => {
        try {
            setisloader(true);

            // If all rows are selected, delete the entire package
            // if (delIDs.length === surgeryLineItem.length && apiDeleteIDs.length > 0) {
            //     await deleteSurgeryMapping();
            //     return;
            // }
            if (Array.isArray(delIDs) && Array.isArray(surgeryLineItem) && Array.isArray(apiDeleteIDs)) {
                if (((delIDs.length === surgeryLineItem.length) || (delIDs.length === serviceDetails.length)) && apiDeleteIDs.length > 0) {
                    await deleteSurgeryMapping();
                    return;
                }
            }

            // Remove items locally that don't require an API call
            if (localDeleteIDs.length > 0) {
                setServiceDetails(prevState => prevState.filter(item => !localDeleteIDs.includes(item.sno)));
            }

            // API call if there are IDs to delete from backend
            if (apiDeleteIDs.length > 0) {
                try {
                    const response = await RestAPIService.delete(
                        `${Serviceurls.SURGERY_MAPPING_CONFIGURATION}?delete_type=individual&id=${apiDeleteIDs}`,
                        {}
                    );
                    if (response.data.status === 'success') {
                        successMessage(response.data.message);
                        closeFilter();
                        getSurgeryIndividual(TempId);
                    }
                } catch (e) {
                    if (e?.response?.data?.status === 'fail') {
                        errorMessage(e.response.data.message);
                    } else {
                        errorMessage(e.message);
                    }
                }
            }
            else {
                closeFilter();
            }
        } catch (e) {
            errorMessage(e.message);
        } finally {
            setisloader(false); // Ensure loader is disabled in all cases
        }
    };


    const prevent = () => {
        history.push("/Settings/NewService/SurgeryMapping");
    };

    return (
        <Box component={'div'} sx={{ height: '85vh', width: '94vw', backgroundColor: Colors.Background, padding: '.5vw' }}>
            <Box component={'div'} height={'5vh'} display={'flex'} alignItems={'center'} sx={{ backgroundColor: 'white', borderBottom: '1px solid lightgray' }}>
                <IconButton onClick={() => prevent()}>
                    <ChevronLeftIcon color='primary' />
                </IconButton>
                <Typography color={Colors.SecondaryText} fontWeight={600} fontSize={"0.95vw"}>{'Back To Surgery Mapping'}</Typography>
            </Box>
            <Box component={'div'} sx={{ height: '14vh', width: '93vw', backgroundColor: 'white', mt: "1vw" }}>
                <Box component={'div'} height={'5vh'} display={'flex'} alignItems={'center'} justifyContent={'space-between'} sx={{ backgroundColor: 'white', borderBottom: '1px solid lightgray', paddingLeft: "0.5vw" }}>
                    <Typography color={Colors.SecondaryText} fontWeight={600} fontSize={"0.95vw"}>{'Surgery Configuration'}</Typography>
                </Box>
                <Box component={'div'} style={{ display: 'flex', flexDirection: 'row', alignItems: "center", justifyContent: "space-between", height: "9vh", paddingLeft: "0.5vw" }}>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: "center", height: "9vh", paddingLeft: "0.5vw" }}>
                        {textBox("Surgery Mapping Code", 'surgeryCode', formState?.surgeryCode, '15vw', true)}
                        {autoComplete("Select Surgery Name", 'surgeryName', formState?.surgeryName, formState?.surgeryNameList, '15vw', TempId)}
                        <FormControlLabel control={<Checkbox checked={isActive} onChange={(e) => { setIsActive(e.target.checked) }} size='small' />} label={"Active"} />
                    </div>
                    <div>
                        {delIDs?.length > 0 && <Button size='small' disabled={!commonDisable} variant='contained' color='error' sx={{ textTransform: 'capitalize', width: '5vw', marginRight: '0.5vw' }} onClick={() => { grpDelete() }}>Delete</Button>}
                        <Button size='small' variant='contained' disabled={serviceDetails.length <= 0 && !commonDisable} sx={{ textTransform: 'capitalize', width: '5vw', marginRight: '0.5vw' }} onClick={() => { AddSurgeryData() }}>{TempId ? 'Update' : 'Save'}</Button>
                    </div>

                </Box>
            </Box>

            <Box component={'div'} sx={{ height: '14vh', width: '93vw', backgroundColor: 'white', mt: "0.5vw" }}>
                <Box component={'div'} height={'5vh'} display={'flex'} alignItems={'center'} sx={{ backgroundColor: 'white', borderBottom: '1px solid lightgray', paddingLeft: "0.5vw" }}>
                    <Typography color={Colors.SecondaryText} fontWeight={600} fontSize={"0.95vw"}>{'Package Configuration'}</Typography>
                </Box>
                <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row', alignItems: "center", height: "9vh", paddingLeft: "0.5vw" }}>
                    {autoComplete("Search Package*", 'selectedPackageData', formState?.selectedPackageData, formState?.PackageList, '30.3vw')}
                    <Button variant='outlined' sx={{ textTransform: 'capitalize', width: '7vw' }} onClick={() => {
                        setFormState((prevState) => ({ ...prevState, selectedPackageData: null }));
                    }}>Clear</Button>
                    <Button variant='contained' disabled={!commonDisable || formState?.selectedPackageData === null} sx={{ textTransform: 'capitalize', width: '7vw', marginLeft: '0.5vw' }} onClick={() => { AddTable() }}>Add</Button>
                </Box>
            </Box>

            <Box component={'div'} sx={{ height: '47vh', width: '93vw', marginTop: '.5vw', backgroundColor: 'white', }}>
                {tableView()}
            </Box>

            {errorMsg ?
                <ToastMsg
                    severity={'error'}
                    msg={errorMsgText}
                    msgPop={msgClose}
                />
                : null}
            {successMsg ?
                <ToastMsg
                    severity={'success'}
                    msg={successMsgText}
                    msgPop={msgClose}
                />
                : null}
            {isDelete ?
                <DeletePopup
                    DeletTitle={
                        (surgeryLineItem?.length === delIDs.length && apiDeleteIDs.length > 0)
                            ? "Are you sure? Deleting this will remove the entire package!"
                            : "Are you sure, Do you want to delete this item?"
                    }
                    DeleteN DeleteNotify={
                        (surgeryLineItem?.length === delIDs.length && apiDeleteIDs.length > 0)
                            ? "If you remove this, the entire package will be deleted."
                            : "If you remove this, this could affect the entire Configuration."
                    }
                    deleteAlertPopupClose={closeFilter}
                    removeData={deleteIndivudualData}
                />
                : null}
            <Loader loaderOpen={isloader} />
        </Box>
    )
}